export const formatCardProcessingFee = (percent: number, fixedAmount: number): string | null => {
  if (percent === 0 && fixedAmount === 0) return null;
  const pct = (percent <= 1 ? percent * 100 : percent).toFixed(2);
  const formattedFixedAmount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(fixedAmount);
  const flat = fixedAmount > 0 ? ` + ${formattedFixedAmount}` : '';
  return `${pct}%${flat}`;
};
